"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _utils = require("../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LanguageSelectionCell = /*#__PURE__*/function (_react$default$Compon) {
  function LanguageSelectionCell() {
    _classCallCheck(this, LanguageSelectionCell);
    return _callSuper(this, LanguageSelectionCell, arguments);
  }
  _inherits(LanguageSelectionCell, _react$default$Compon);
  return _createClass(LanguageSelectionCell, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return (0, _utils.shouldCellComponentUpdate)(this.props, nextProps) || this.state !== nextState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        project = _this$props.project,
        intl = _this$props.intl,
        displayLanguageModal = _this$props.displayLanguageModal;
      var flagBg = project.language_selector_display_type === 'flag' ? {
        background: "url(\"".concat((0, _utils.flagUri)(project, intl.locale), "\") center center / cover")
      } : {};
      return /*#__PURE__*/_react.default.createElement("div", {
        onClick: displayLanguageModal,
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tsku-language-selector tsku-language-selector-".concat(project.language_selector_shape),
        style: _objectSpread({
          background: project.language_selector_background_color,
          border: "1px solid ".concat(project.language_selector_border_color),
          color: project.language_selector_text_color
        }, project.language_selector_shape === 'circle' ? flagBg : {})
      }, project.language_selector_display_type === 'country_code' && /*#__PURE__*/_react.default.createElement("span", null, intl.locale), project.language_selector_display_type === 'flag' && project.language_selector_shape !== 'circle' && /*#__PURE__*/_react.default.createElement("div", {
        className: "tsk-flag-circle",
        style: flagBg
      }), project.language_selector_shape === 'rectangle' && /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        style: {
          marginLeft: '0.5em'
        },
        icon: 'chevron-down'
      })));
    }
  }]);
}(_react.default.Component);
_defineProperty(LanguageSelectionCell, "whyDidYouRender", true);
var _default = exports.default = (0, _reactIntl.injectIntl)(LanguageSelectionCell);